/* eslint-disable react/prop-types */
import { Box, CircularProgress, Tooltip, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import { DataGrid } from '@mui/x-data-grid';

// Batches Modal Child Component of dashboard left side
export function BatchesModalBox(props) {
	const [batchesVisitData, setBatchesVisitData] = useState([]);
	const columns = [
		{ field: 'patientName', headerName: 'Patient Name', width: 130 },
		{ field: 'providerName', headerName: 'Provider Name', width: 130 },
		{ field: 'visitDate', headerName: 'Visit Date', width: 120 },
		{ field: 'AdmissionDate', headerName: 'Admission Date', width: 130 },
		{
			field: 'codes',
			headerName: 'Codes',
			width: 250,
			renderCell: (items) => {
				return (
					<Box
						style={
							{
								// width: '100%',
								// height: '60px',
								// overflow: 'auto',
							}
						}
						sx={{
							'&::-webkit-scrollbar': {
								width: '1px',
								height: '3px',
							},
							'&::-webkit-scrollbar-track': {
								background: 'grey',
							},
							'&::-webkit-scrollbar-thumb': {
								background: '#0E4374',
								borderRadius: '5px',
							},
						}}
						display={'flex'}
						flexDirection={'column'}
					>
						<span
							style={{
								color: '#4D7BDE',
								fontWeight: 600,
								fontSize: '13px',
								width: '100%',
							}}
						>
							{' '}
							{items?.row?.visit_cpts?.length > 0
								? items?.row?.visit_cpts?.map(
										(data) => data?.CPTCode !== null && data?.CPTCode + ','
									)
								: ' '}
						</span>
						<Box fontSize={'13px'}>
							<Tooltip
								title={
									<>
										{items?.row?.Dx1Description &&
											`${items?.row?.Dxcode1} ${items?.row?.Dx1Description}`}
										{items?.row?.Dx1Description && <br />}
										{items?.row?.Dx2Description &&
											`${items?.row?.Dxcode2} ${items?.row?.Dx2Description}`}
										{items?.row?.Dx2Description && <br />}
										{items?.row?.Dx3Description &&
											`${items?.row?.Dxcode3} ${items?.row?.Dx3Description}`}
										{items?.row?.Dx3Description && <br />}
										{items?.row?.Dx4Description &&
											`${items?.row?.Dxcode4} ${items?.row?.Dx4Description}`}
										{items?.row?.Dx4Description && <br />}
										{items?.row?.Dx5Description &&
											`${items?.row?.Dxcode5} ${items?.row?.Dx5Description}`}
										{items?.row?.Dx5Description && <br />}
										{items?.row?.Dx6Description &&
											`${items?.row?.Dxcode6} ${items?.row?.Dx6Description}`}
										{items?.row?.Dx6Description && <br />}
										{items?.row?.Dx7Description &&
											`${items?.row?.Dxcode7} ${items?.row?.Dx7Description}`}
										{items?.row?.Dx7Description && <br />}
										{items?.row?.Dx8Description &&
											`${items?.row?.Dxcode8} ${items?.row?.Dx8Description}`}
										{items?.row?.Dx8Description && <br />}
										{items?.row?.Dx9Description &&
											`${items?.row?.Dxcode9} ${items?.row?.Dx9Description}`}
										{items?.row?.Dx9Description && <br />}
										{items?.row?.Dx10Description &&
											`${items?.row?.Dxcode10} ${items?.row?.Dx10Description}`}
										{items?.row?.Dx10Description && <br />}
										{items?.row?.Dx11Description &&
											`${items?.row?.Dxcode11} ${items?.row?.Dx11Description}`}
										{items?.row?.Dx11Description && <br />}
										{items?.row?.Dx12Description &&
											`${items?.row?.Dxcode12} ${items?.row?.Dx12Description}`}
										{items?.row?.Dx12Description && <br />}
									</>
								}
							>
								<Typography
									variant="body2"
									sx={{
										textOverflow: 'ellipsis',
										overflow: 'hidden',
										whiteSpace: 'nowrap',
										width: 200,
										fontSize: {
											xl: '13px',
											lg: '10px',
											md: '10px',
											sm: '10px',
											xs: '10px',
										},
									}}
								>
									{items?.row?.Dxcode1} {items?.row?.Dx1Description}
									{/* <br />
									{items?.row?.Dxcode2} {items?.row?.Dx2Description}{' '} */}
								</Typography>
							</Tooltip>
						</Box>
					</Box>
				);
			},
		},

		{ field: 'locationName', headerName: 'Location', width: 130 },
		{
			field: 'VisitStatus',
			headerName: 'Status',
			width: 60,
			// renderCell: (params) => {
			// 	return (
			// 		<span
			// 			style={{
			// 				fontFamily: 'Poppins',
			// 				fontSize: '13px',
			// 				color: '#FEAB13',
			// 			}}
			// 		>
			// 			{params?.VisitStatus}
			// 		</span>
			// 	);
			// },
		},
	];

	useEffect(() => {
		setBatchesVisitData(
			props.batchesVisitDataProp.map((item) => ({
				...item,
				patientName: `${item?.patient?.Fname} ${item?.patient?.Lname}`,
				providerName: `${item?.practicestaff?.Fname}, ${item?.practicestaff?.Lname}`,
				visitDate: `${dayjs(item?.VisitDate).format(`DD/MM/YYYY  `)}`,
				AdmissionDate: `${dayjs(item?.admission?.Admission_date).format('MM/DD/YYYY')}`,
				locationName: item?.location?.Name,
				VisitStatus:
					item?.VisitStatus === 'B'
						? 'Billed'
						: item?.VisitStatus === 'D'
							? 'Draft'
							: item?.VisitStatus === 'A'
								? 'Approved'
								: item?.VisitStatus === 'O'
									? 'Others'
									: '',
			}))
		);
	}, []);
	return (
		<div>
			<Box
				sx={{
					width: '100%',
					height: {
						xl: '65vh',
						md: '43vh',
						lg: '49vh',
						sm: '55vh',
						xs: '55vh',
					},
					overflow: 'auto',
				}}
			>
				{' '}
				<DataGrid
					rows={batchesVisitData}
					columns={columns}
					rowHeight={40}
					columnHeaderHeight={35}
					fontFamily={'Poppins'}
					// checkboxSelection
					disableRowSelectionOnClick
					sx={{
						'& .MuiDataGrid-columnHeaders': {
							backgroundColor: '#2081B8',
							color: '#FFFFFF',
						},
						fontSize: {
							xl: '13px',
							lg: '10px',
							md: '10px',
							sm: '10px',
							xs: '10px',
						},
					}}
					pageSizeOptions={[10, 25, 50, 100]}
				/>
			</Box>
		</div>
	);
}

export function DraftVisits(props) {
	const [pageSizeOptions, setPageSizeOptions] = useState(10); // Set the initial page size
	const [pagination, setPagination] = useState(null);
	const [draftVisitData, setDraftVisitData] = useState([]);

	useEffect(() => {
		setDraftVisitData(
			props.draftVisitsDataProp.map((item) => ({
				...item,
				patientName: `${item?.patient?.Fname} ${item?.patient?.Lname}`,
				providerName: `${item?.provider}`,
				visitDate: `${dayjs(item?.VisitDate).format(`MM/DD/YYYY  `)}`,
				AdmissionDate: `${dayjs(item?.admission?.Admission_date).format('MM/DD/YYYY')}`,
				locationName: item?.location,
				visitStatus: item?.VisitStatus === 'D' ? 'Draft' : '',
			}))
		);
	}, [props.draftVisitsDataProp]);

	const columns = [
		{ field: 'patientName', headerName: 'Patient Name', width: 130 },
		{
			field: 'providerName',
			headerName: 'Provider Name',
			width: 130,
			renderCell: (params) => {
				return (
					<Box>
						<span>
							{params?.row?.provider == ', '
								? params?.row?.provider == ''
								: params?.row?.provider}
						</span>
					</Box>
				);
			},
		},
		{ field: 'visitDate', headerName: 'Visit Date', width: 120 },
		{
			field: 'AdmissionDate',
			headerName: 'Admission Date',
			width: 130,
		},
		{
			field: 'codes',
			headerName: 'Codes',
			width: 250,
			renderCell: (items) => {
				return (
					<Box
						fontSize={'13px'}
						sx={{
							textOverflow: 'ellipsis',
							overflow: 'hidden',
							whiteSpace: 'nowrap',
						}}
					>
						<Tooltip
							title={
								<>
									{items?.row?.Dx1Description &&
										`${items?.row?.Dxcode1} ${items?.row?.Dx1Description}`}
									{items?.row?.Dx1Description && <br />}
									{items?.row?.Dx2Description &&
										`${items?.row?.Dxcode2} ${items?.row?.Dx2Description}`}
									{items?.row?.Dx2Description && <br />}
									{items?.row?.Dx3Description &&
										`${items?.row?.Dxcode3} ${items?.row?.Dx3Description}`}
									{items?.row?.Dx2Description && <br />}
									{items?.row?.Dx4Description &&
										`${items?.row?.Dxcode4} ${items?.row?.Dx4Description}`}
									{items?.row?.Dx4Description && <br />}
									{items?.row?.Dx5Description &&
										`${items?.row?.Dxcode5} ${items?.row?.Dx5Description}`}
									{items?.row?.Dx5Description && <br />}
									{items?.row?.Dx6Description &&
										`${items?.row?.Dxcode6} ${items?.row?.Dx6Description}`}
									{items?.row?.Dx6Description && <br />}
									{items?.row?.Dx7Description &&
										`${items?.row?.Dxcode7} ${items?.row?.Dx7Description}`}
									{items?.row?.Dx7Description && <br />}
									{items?.row?.Dx8Description &&
										`${items?.row?.Dxcode8} ${items?.row?.Dx8Description}`}
									{items?.row?.Dx8Description && <br />}
									{items?.row?.Dx9Description &&
										`${items?.row?.Dxcode9} ${items?.row?.Dx9Description}`}
									{items?.row?.Dx9Description && <br />}
									{items?.row?.Dx10Description &&
										`${items?.row?.Dxcode10} ${items?.row?.Dx10Description}`}
									{items?.row?.Dx10Description && <br />}
									{items?.row?.Dx11Description &&
										`${items?.row?.Dxcode11} ${items?.row?.Dx11Description}`}
									{items?.row?.Dx11Description && <br />}
									{items?.row?.Dx12Description &&
										`${items?.row?.Dxcode12} ${items?.row?.Dx12Description}`}
								</>
							}
						>
							<Typography
								variant="body2"
								sx={{
									color: '#4D7BDE',
									// fontWeight: 600,
									fontSize: {
										xl: '13px',
										lg: '10px',
										md: '10px',
										xs: '10px',
										sm: '10px',
									},
									width: '100%',
									textOverflow: 'ellipsis',
									overflow: 'hidden',
									whiteSpace: 'nowrap',
								}}
							>
								{' '}
								{items?.row?.visit_cpts?.length > 0
									? items?.row?.visit_cpts?.map(
											(data) =>
												data?.CPTCode !== null &&
												data?.CPTCode + (data?.CPTCode?.length > 0 ? ',' : '')
										)
									: ' '}
							</Typography>
							<Typography
								variant="body2"
								sx={{
									fontSize: {
										xl: '13px',
										lg: '10px',
										md: '10px',
										xs: '10px',
										sm: '10px',
									},
									textOverflow: 'ellipsis',
									overflow: 'hidden',
									whiteSpace: 'nowrap',
									width: 200,
								}}
							>
								{items?.row?.Dxcode1} {items?.row?.Dx1Description}
								{/* <br /> */}
								{/* {items?.row?.Dxcode2} {items?.row?.Dx2Description}{' '} */}
							</Typography>
						</Tooltip>
					</Box>
				);
			},
		},

		{ field: 'locationName', headerName: 'Location', width: 130 },
	];
	return (
		<div>
			{draftVisitData.length === 0 && (
				<Box
					width={'100%'}
					display={'flex'}
					justifyContent={'center'}
					alignItems={'center'}
					mt={1}
				>
					{/* 0 Record */}
					<CircularProgress />
				</Box>
			)}
			<Box
				sx={{
					width: '100%',
					height: {
						xl: '65vh',
						md: '50vh',
						lg: '49vh',
						sm: '55vh',
						xs: '55vh',
					},
					overflow: 'auto',
				}}
			>
				{' '}
				<DataGrid
					rows={draftVisitData}
					columns={columns}
					rowHeight={40}
					columnHeaderHeight={35}
					fontFamily={'Poppins'}
					// checkboxSelection
					disableRowSelectionOnClick
					initialState={{
						pagination: { paginationModel: { pageSize: 10 } },
					}}
					sx={{
						'& .MuiDataGrid-columnHeaders': {
							backgroundColor: '#2081B8',
							color: '#FFFFFF',
						},
						fontSize: {
							xl: '13px',
							lg: '10px',
							md: '10px',
							xs: '10px',
							sm: '10px',
						},
					}}
					pageSizeOptions={[10, 25, 50, 100]}
				/>
			</Box>
		</div>
	);
}

export function ApprovedVisits(props) {
	const [approvedVisitData, setApprovedVisitData] = useState([]);

	useEffect(() => {
		setApprovedVisitData(
			props.approvedVisitsDataProp.map((item) => ({
				...item,
				patientName: `${item?.patient?.Fname} ${item?.patient?.Lname}`,
				providerName: `${item?.provider}`,
				visitDate: `${dayjs(item?.VisitDate).format(`MM/DD/YYYY  `)}`,
				AdmissionDate: `${dayjs(item?.admission?.Admission_date).format('MM/DD/YYYY')}`,
				locationName: item?.location,
				visitStatus: item?.VisitStatus === 'A' ? 'Approved' : '',
			}))
		);
	}, [props.approvedVisitsDataProp]);
	const columns = [
		{ field: 'patientName', headerName: 'Patient Name', width: 130 },
		{
			field: 'providerName',
			headerName: 'Provider Name',
			width: 130,
			renderCell: (params) => {
				return (
					<Box>
						<span>
							{params?.row?.provider == ', '
								? params?.row?.provider == ''
								: params?.row?.provider}
						</span>
					</Box>
				);
			},
		},
		{ field: 'visitDate', headerName: 'Visit Date', width: 120 },
		{ field: 'AdmissionDate', headerName: 'Admission Date', width: 130 },
		{
			field: 'codes',
			headerName: 'Codes',
			width: 250,
			renderCell: (items) => {
				return (
					<Box
						sx={{
							'&::-webkit-scrollbar': {
								width: '1px',
								height: '3px',
							},
							'&::-webkit-scrollbar-track': {
								background: 'grey',
							},
							'&::-webkit-scrollbar-thumb': {
								background: '#0E4374',
								borderRadius: '5px',
							},
						}}
						display={'flex'}
						flexDirection={'column'}
					>
						<span
							style={{
								color: '#4D7BDE',
								fontWeight: 600,
								fontSize: {
									xl: '13px',
									lg: '10px',
									md: '10px',
									xs: '10px',
									sm: '10px',
								},
								width: '100%',
							}}
						>
							{' '}
							{items?.row?.visit_cpts?.length > 0
								? items?.row?.visit_cpts?.map(
										(data) =>
											data?.CPTCode !== null &&
											data?.CPTCode + (data?.CPTCode?.length > 0 ? ',' : '')
									)
								: ' '}
						</span>
						<Box fontSize={'10px'}>
							<Tooltip
								title={
									<>
										{items?.row?.Dx1Description &&
											`${items?.row?.Dxcode1} ${items?.row?.Dx1Description}`}
										{items?.row?.Dx1Description && <br />}
										{items?.row?.Dx2Description &&
											`${items?.row?.Dxcode2} ${items?.row?.Dx2Description}`}
										{items?.row?.Dx2Description && <br />}
										{items?.row?.Dx3Description &&
											`${items?.row?.Dxcode3} ${items?.row?.Dx3Description}`}
										{items?.row?.Dx3Description && <br />}
										{items?.row?.Dx4Description &&
											`${items?.row?.Dxcode4} ${items?.row?.Dx4Description}`}
										{items?.row?.Dx4Description && <br />}
										{items?.row?.Dx5Description &&
											`${items?.row?.Dxcode5} ${items?.row?.Dx5Description}`}
										{items?.row?.Dx5Description && <br />}
										{items?.row?.Dx6Description &&
											`${items?.row?.Dxcode6} ${items?.row?.Dx6Description}`}
										{items?.row?.Dx6Description && <br />}
										{items?.row?.Dx7Description &&
											`${items?.row?.Dxcode7} ${items?.row?.Dx7Description}`}
										{items?.row?.Dx7Description && <br />}
										{items?.row?.Dx8Description &&
											`${items?.row?.Dxcode8} ${items?.row?.Dx8Description}`}
										{items?.row?.Dx8Description && <br />}
										{items?.row?.Dx9Description &&
											`${items?.row?.Dxcode9} ${items?.row?.Dx9Description}`}
										{items?.row?.Dx9Description && <br />}
										{items?.row?.Dx10Description &&
											`${items?.row?.Dxcode10} ${items?.row?.Dx10Description}`}
										{items?.row?.Dx10Description && <br />}
										{items?.row?.Dx11Description &&
											`${items?.row?.Dxcode11} ${items?.row?.Dx11Description}`}
										{items?.row?.Dx11Description && <br />}
										{items?.row?.Dx12Description &&
											`${items?.row?.Dxcode12} ${items?.row?.Dx12Description}`}
										{items?.row?.Dx12Description && <br />}
									</>
								}
							>
								<Typography
									variant="body2"
									sx={{
										textOverflow: 'ellipsis',
										overflow: 'hidden',
										whiteSpace: 'nowrap',
										width: 200,
										fontSize: {
											xl: '13px',
											lg: '10px',
											md: '10px',
											xs: '10px',
											sm: '10px',
										},
									}}
								>
									{items?.row?.Dxcode1} {items?.row?.Dx1Description}
									{/* <br />
									{items?.row?.Dxcode2} {items?.row?.Dx2Description}{' '} */}
								</Typography>
							</Tooltip>
						</Box>
					</Box>
				);
			},
		},

		{ field: 'locationName', headerName: 'Location', width: 130 },
	];

	return (
		<div>
			{approvedVisitData.length === 0 && (
				<Box
					width={'100%'}
					display={'flex'}
					justifyContent={'center'}
					alignItems={'center'}
					mt={1}
				>
					{/* 0 Record */}
					<CircularProgress />
				</Box>
			)}
			<Box
				sx={{
					width: '100%',
					height: {
						xl: '65vh',
						md: '50vh',
						lg: '50vh',
						sm: '55vh',
						xs: '55vh',
					},
					overflow: 'auto',
				}}
			>
				{' '}
				<DataGrid
					rows={approvedVisitData}
					columns={columns}
					rowHeight={40}
					columnHeaderHeight={35}
					fontFamily={'Poppins'}
					// checkboxSelection
					disableRowSelectionOnClick
					initialState={{
						pagination: { paginationModel: { pageSize: 10 } },
					}}
					sx={{
						'& .MuiDataGrid-columnHeaders': {
							backgroundColor: '#2081B8',
							color: '#FFFFFF',
						},
						fontSize: {
							xl: '13px',
							lg: '10px',
							md: '10px',
							xs: '10px',
							sm: '10px',
						},
					}}
					pageSizeOptions={[10, 25, 50, 100]}
				/>
			</Box>
		</div>
	);
}

export function RejectedVisits(props) {
	const [otherVisitData, setOtherVisitData] = useState([]);

	// useEffect(() => {
	// 	setOtherVisitData(props.otherVisitsDataProp);
	// }, []);

	useEffect(() => {
		setOtherVisitData(
			props.otherVisitsDataProp.map((item) => ({
				...item,
				patientName: `${item?.patient?.Fname} ${item?.patient?.Lname}`,
				providerName: `${item?.practicestaff?.Fname}, ${item?.practicestaff?.Lname}`,
				visitDate: `${dayjs(item?.VisitDate).format(`DD/MM/YYYY  `)}`,
				AdmissionDate: `${dayjs(item?.admission?.Admission_date).format('MM/DD/YYYY')}`,
				locationName: item?.location?.Name,
				visitStatus: item?.VisitStatus === 'O' ? 'Other' : '',
			}))
		);
	}, [props.otherVisitsDataProp]);
	const columns = [
		{ field: 'patientName', headerName: 'Patient Name', width: 130 },
		{ field: 'providerName', headerName: 'Provider Name', width: 130 },
		{ field: 'visitDate', headerName: 'Visit Date', width: 120 },
		{ field: 'AdmissionDate', headerName: 'Admission Date', width: 130 },
		{
			field: 'codes',
			headerName: 'Codes',
			width: 250,
			renderCell: (items) => {
				return (
					<Box
						style={
							{
								// width: '100%',
								// height: '60px',
								// overflow: 'auto',
							}
						}
						sx={{
							'&::-webkit-scrollbar': {
								width: '1px',
								height: '3px',
							},
							'&::-webkit-scrollbar-track': {
								background: 'grey',
							},
							'&::-webkit-scrollbar-thumb': {
								background: '#0E4374',
								borderRadius: '5px',
							},
						}}
						display={'flex'}
						flexDirection={'column'}
					>
						<Typography
							sx={{
								color: '#4D7BDE',
								fontWeight: 600,
								fontSize: {
									xl: '13px',
									lg: '10px',
									md: '10px',
									sm: '10px',
									xs: '10px',
								},
								width: '100%',
							}}
						>
							{' '}
							{items?.row?.visit_cpts?.length > 0
								? items?.row?.visit_cpts?.map(
										(data) => data?.CPTCode !== null && data?.CPTCode + ','
									)
								: ' '}
						</Typography>
						<Box fontSize={'13px'}>
							<Tooltip
								title={
									<>
										{items?.row?.Dx1Description &&
											`${items?.row?.Dxcode1} ${items?.row?.Dx1Description}`}
										{items?.row?.Dx1Description && <br />}
										{items?.row?.Dx2Description &&
											`${items?.row?.Dxcode2} ${items?.row?.Dx2Description}`}
										{items?.row?.Dx2Description && <br />}
										{items?.row?.Dx3Description &&
											`${items?.row?.Dxcode3} ${items?.row?.Dx3Description}`}
										{items?.row?.Dx3Description && <br />}
										{items?.row?.Dx4Description &&
											`${items?.row?.Dxcode4} ${items?.row?.Dx4Description}`}
										{items?.row?.Dx4Description && <br />}
										{items?.row?.Dx5Description &&
											`${items?.row?.Dxcode5} ${items?.row?.Dx5Description}`}
										{items?.row?.Dx5Description && <br />}
										{items?.row?.Dx6Description &&
											`${items?.row?.Dxcode6} ${items?.row?.Dx6Description}`}
										{items?.row?.Dx6Description && <br />}
										{items?.row?.Dx7Description &&
											`${items?.row?.Dxcode7} ${items?.row?.Dx7Description}`}
										{items?.row?.Dx7Description && <br />}
										{items?.row?.Dx8Description &&
											`${items?.row?.Dxcode8} ${items?.row?.Dx8Description}`}
										{items?.row?.Dx8Description && <br />}
										{items?.row?.Dx9Description &&
											`${items?.row?.Dxcode9} ${items?.row?.Dx9Description}`}
										{items?.row?.Dx9Description && <br />}
										{items?.row?.Dx10Description &&
											`${items?.row?.Dxcode10} ${items?.row?.Dx10Description}`}
										{items?.row?.Dx10Description && <br />}
										{items?.row?.Dx11Description &&
											`${items?.row?.Dxcode11} ${items?.row?.Dx11Description}`}
										{items?.row?.Dx11Description && <br />}
										{items?.row?.Dx12Description &&
											`${items?.row?.Dxcode12} ${items?.row?.Dx12Description}`}
										{items?.row?.Dx12Description && <br />}
									</>
								}
							>
								<Typography
									variant="body2"
									sx={{
										textOverflow: 'ellipsis',
										overflow: 'hidden',
										whiteSpace: 'nowrap',
										width: 200,
										fontSize: {
											xl: '13px',
											lg: '10px',
											md: '10px',
											xs: '10px',
											sm: '10px',
										},
									}}
								>
									{items?.row?.Dxcode1} {items?.row?.Dx1Description}
								</Typography>
							</Tooltip>
						</Box>
					</Box>
				);
			},
		},

		{ field: 'locationName', headerName: 'Location', width: 130 },
	];
	return (
		<div>
			{otherVisitData?.length === 0 && (
				<Box
					width={'100%'}
					display={'flex'}
					justifyContent={'center'}
					alignItems={'center'}
					mt={1}
				>
					{/* 0 Record */}
					<CircularProgress />
				</Box>
			)}

			<Box
				sx={{
					width: '100%',
					height: {
						xl: '65vh',
						md: '50vh',
						lg: '50vh',
						sm: '55vh',
						xs: '55vh',
					},
					overflow: 'auto',
				}}
			>
				{' '}
				<DataGrid
					rows={otherVisitData}
					columns={columns}
					rowHeight={40}
					columnHeaderHeight={35}
					sx={{
						'& .MuiDataGrid-columnHeaders': {
							backgroundColor: '#2081B8',
							color: '#FFFFFF',
						},
						fontSize: {
							xl: '13px',
							lg: '10px',
							md: '10px',
							xs: '10px',
							sm: '10px',
						},
					}}
					fontFamily={'Poppins'}
					// checkboxSelection
					disableRowSelectionOnClick
					initialState={{
						pagination: { paginationModel: { pageSize: 10 } },
					}}
					pageSizeOptions={[10, 25, 50, 100]}
				/>
			</Box>
		</div>
	);
}
export function BilledVisits(props) {
	const [billedVisitData, setBilledVisitData] = useState([]);

	// useEffect(() => {
	// 	setBilledVisitData(props.billedvisitsDataProp);
	// }, []);

	useEffect(() => {
		setBilledVisitData(
			props?.billedvisitsDataProp?.map((item) => ({
				...item,
				patientName: `${item?.patient?.Fname} ${item?.patient?.Lname}`,
				providerName: `${item?.provider}`,
				visitDate: `${dayjs(item?.VisitDate).format(`MM/DD/YYYY  `)}`,
				AdmissionDate: `${dayjs(item?.admission?.Admission_date).format('MM/DD/YYYY')}`,
				locationName: item?.location,
				visitStatus: item?.VisitStatus === 'B' ? 'Billed' : '',
			}))
		);
	}, [props.billedvisitsDataProp]);
	const columns = [
		{ field: 'patientName', headerName: 'Patient Name', width: 130 },
		{
			field: 'providerName',
			headerName: 'Provider Name',
			width: 130,
			renderCell: (params) => {
				return (
					<Box>
						<span>
							{params?.row?.provider == ', '
								? params?.row?.provider == ''
								: params?.row?.provider}
						</span>
					</Box>
				);
			},
		},
		{ field: 'visitDate', headerName: 'Visit Date', width: 120 },
		{ field: 'AdmissionDate', headerName: 'Admission Date', width: 130 },
		{
			field: 'codes',
			headerName: 'Codes',
			width: 250,
			renderCell: (items) => {
				return (
					<Box
						sx={{
							'&::-webkit-scrollbar': {
								width: '1px',
								height: '3px',
							},
							'&::-webkit-scrollbar-track': {
								background: 'grey',
							},
							'&::-webkit-scrollbar-thumb': {
								background: '#0E4374',
								borderRadius: '5px',
							},
						}}
						display={'flex'}
						flexDirection={'column'}
					>
						<Typography
							sx={{
								color: '#4D7BDE',
								// fontWeight: 600,
								fontSize: {
									xl: '13px',
									lg: '10px',
									md: '10px',
									sm: '10px',
									xs: '10px',
								},
								width: '100%',
							}}
						>
							{' '}
							{items?.row?.visit_cpts?.length > 0
								? items?.row?.visit_cpts?.map(
										(data) =>
											data?.CPTCode !== null &&
											data?.CPTCode + (data?.CPTCode?.length > 0 ? ',' : '')
									)
								: ' '}
						</Typography>
						<Box fontSize={'13px'}>
							<Tooltip
								title={
									<>
										{items?.row?.Dx1Description &&
											`${items?.row?.Dxcode1} ${items?.row?.Dx1Description}`}
										{items?.row?.Dx1Description && <br />}
										{items?.row?.Dx2Description &&
											`${items?.row?.Dxcode2} ${items?.row?.Dx2Description}`}
										{items?.row?.Dx2Description && <br />}
										{items?.row?.Dx3Description &&
											`${items?.row?.Dxcode3} ${items?.row?.Dx3Description}`}
										{items?.row?.Dx3Description && <br />}
										{items?.row?.Dx4Description &&
											`${items?.row?.Dxcode4} ${items?.row?.Dx4Description}`}
										{items?.row?.Dx4Description && <br />}
										{items?.row?.Dx5Description &&
											`${items?.row?.Dxcode5} ${items?.row?.Dx5Description}`}
										{items?.row?.Dx5Description && <br />}
										{items?.row?.Dx6Description &&
											`${items?.row?.Dxcode6} ${items?.row?.Dx6Description}`}
										{items?.row?.Dx6Description && <br />}
										{items?.row?.Dx7Description &&
											`${items?.row?.Dxcode7} ${items?.row?.Dx7Description}`}
										{items?.row?.Dx7Description && <br />}
										{items?.row?.Dx8Description &&
											`${items?.row?.Dxcode8} ${items?.row?.Dx8Description}`}
										{items?.row?.Dx8Description && <br />}
										{items?.row?.Dx9Description &&
											`${items?.row?.Dxcode9} ${items?.row?.Dx9Description}`}
										{items?.row?.Dx9Description && <br />}
										{items?.row?.Dx10Description &&
											`${items?.row?.Dxcode10} ${items?.row?.Dx10Description}`}
										{items?.row?.Dx10Description && <br />}
										{items?.row?.Dx11Description &&
											`${items?.row?.Dxcode11} ${items?.row?.Dx11Description}`}
										{items?.row?.Dx11Description && <br />}
										{items?.row?.Dx12Description &&
											`${items?.row?.Dxcode12} ${items?.row?.Dx12Description}`}
										{items?.row?.Dx12Description && <br />}
									</>
								}
							>
								<Typography
									variant="body2"
									sx={{
										textOverflow: 'ellipsis',
										overflow: 'hidden',
										whiteSpace: 'nowrap',
										width: 200,
										fontSize: {
											xl: '13px',
											lg: '10px',
											md: '10px',
											xs: '10px',
											sm: '10px',
										},
									}}
								>
									{items?.row?.Dxcode1} {items?.row?.Dx1Description}
									{/* <br />
									{items?.row?.Dxcode2} {items?.row?.Dx2Description}{' '} */}
								</Typography>
							</Tooltip>
						</Box>
					</Box>
				);
			},
		},

		{ field: 'locationName', headerName: 'Location', width: 130 },
	];

	return (
		<div>
			{billedVisitData.length === 0 && (
				<Box
					width={'100%'}
					display={'flex'}
					justifyContent={'center'}
					alignItems={'center'}
					mt={1}
				>
					{/* 0 Record */}
					<CircularProgress />
				</Box>
			)}
			<Box
				sx={{
					width: '100%',
					height: {
						xl: '65vh',
						md: '50vh',
						lg: '50vh',
						sm: '55vh',
						xs: '55vh',
					},
					overflow: 'auto',
				}}
			>
				{' '}
				<DataGrid
					rows={billedVisitData}
					columns={columns}
					rowHeight={40}
					columnHeaderHeight={35}
					sx={{
						'& .MuiDataGrid-columnHeaders': {
							backgroundColor: '#2081B8',
							color: 'white',
							fontWeight: 600,
							fontFamily: 'Poppins',
						},
						fontSize: {
							xl: '13px',
							lg: '10px',
							md: '10px',
							xs: '10px',
							sm: '10px',
						},
					}}
					fontFamily={'Poppins'}
					// checkboxSelection
					disableRowSelectionOnClick
					initialState={{
						pagination: { paginationModel: { pageSize: 10 } },
					}}
					pageSizeOptions={[10, 25, 50, 100]}
				/>
			</Box>
		</div>
	);
}

export function AllAppointments(props) {
	const [appointmentList, setAppointmentList] = useState([]);

	useEffect(() => {
		setAppointmentList(
			props?.appointmentsDataProp
				?.filter((item) => item?.Status === 'P')
				.map((item) => ({
					...item,
					patientName: `${item?.patient?.Fname} ${item?.patient?.Lname}`,
					Reason: item?.Reason,
					locationName: item?.location?.Name,
					AppointmentDate: dayjs(item?.AppointmentDate).format(
						'DD/MM/YYYY HH:mm:ss A'
					),
					// status: item?.Status=="P"?"Pending":item?.Status=="A"?"Approved":item?.Status=="R"?"Other",
				}))
		);
	}, [props?.appointmentsDataProp]);

	const columns = [
		{ field: 'patientName', headerName: 'Patient Name', width: 150 },
		{
			field: 'Reason',
			headerName: 'Reason',
			width: 150,
		},
		{ field: 'locationName', headerName: 'Location', width: 150 },
		{ field: 'AppointmentDate', headerName: 'Date', width: 150 },
		{
			field: 'status',
			headerName: 'Status',
			width: 130,
			renderCell: (item) => {
				return (
					<Typography
						// fontSize={'13px'}
						fontWeight={500}
						sx={{
							color:
								item?.row?.Status === 'C'
									? 'green'
									: item?.row?.Status === 'D'
										? 'red'
										: item?.row?.Status === 'O'
											? 'grey'
											: '#CBC32A',
							fontSize: {
								xl: '13px',
								lg: '10px',
								md: '10px',
								xs: '10px',
								sm: '10px',
							},
						}}
					>
						{item?.row?.Status === 'C'
							? 'Confirmed'
							: item?.row?.Status === 'D'
								? 'Dismissed'
								: item?.row?.Status === 'O'
									? 'Other'
									: 'Pending'}
					</Typography>
				);
			},
		},
	];
	return (
		<div>
			{appointmentList?.length === 0 && (
				<Box
					width={'100%'}
					display={'flex'}
					justifyContent={'center'}
					alignItems={'center'}
					mt={1}
				>
					{/* 0 Record */}
					<CircularProgress />
				</Box>
			)}
			<Box
				sx={{
					width: '100%',
					height: {
						xl: '65vh',
						md: '50vh',
						lg: '50vh',
						sm: '55vh',
						xs: '55vh',
					},
					overflow: 'auto',
				}}
			>
				{' '}
				<DataGrid
					rows={appointmentList}
					columns={columns}
					rowHeight={35}
					columnHeaderHeight={35}
					sx={{
						'& .MuiDataGrid-columnHeaders': {
							backgroundColor: '#2081B8',
							color: '#FFFFFF',
						},
						fontSize: {
							xl: '13px',
							lg: '10px',
							md: '10px',
							xs: '10px',
							sm: '10px',
						},
					}}
					fontFamily={'Poppins'}
					// checkboxSelection
					disableRowSelectionOnClick
					initialState={{
						pagination: { paginationModel: { pageSize: 10 } },
					}}
					pageSizeOptions={[10, 25, 50, 100]}
				/>
			</Box>
		</div>
	);
}

export function ActivePatients(props) {
	const [activePatients, setActivePatients] = useState([]);

	useEffect(() => {
		setActivePatients(props?.activePatientDataProp);
	}, []);

	const columns = [
		{
			field: 'Name',
			headerName: 'Patient',
			// width: 150,
			flex: 1,
			minWidth: 150,
			renderCell: (params) => {
				console.log('params', params);
				return (
					<Box>
						<span>
							{params?.row?.Name == ', '
								? params?.row?.Name == ''
								: params?.row?.Name}
						</span>
					</Box>
				);
			},
		},
		{
			field: 'provider',
			headerName: 'Provider',
			// width: 120,
			flex: 1,
			minWidth: 120,
			renderCell: (params) => {
				return (
					<Box>
						<span>
							{params?.row?.provider == ', '
								? params?.row?.provider == ''
								: params?.row?.provider}
						</span>
					</Box>
				);
			},
		},
		{
			field: 'MRN',
			headerName: 'MRN',
			//  width: 80
			flex: 0.5,
			minWidth: 100,
		},
		{
			field: 'Admission_date',
			headerName: 'Admission Date',
			// width: 100,
			flex: 0.5,
			minWidth: 150,
			renderCell: (params) => {
				return (
					params?.row?.Admission_date !== null && (
						<span>
							{dayjs(params?.row?.Admission_date).format('MM/DD/YYYY')}
						</span>
					)
				);
			},
		},
		{
			field: 'location',
			headerName: 'Location',
			//  flex: 1
			flex: 1,
			minWidth: 150,
		},
		{
			field: 'DOB',
			headerName: 'DOB',
			// width: 70,
			// flex: 1,
			flex: 0.5,
			minWidth: 100,
			renderCell: (params) => {
				return (
					params?.row?.DOB !== null && (
						<span>{dayjs(params?.row?.DOB).format('MM/DD/YYYY')}</span>
					)
				);
			},
		},
		{
			field: 'Inactive',
			headerName: 'Status',
			// width: 70,
			flex: 0.5,
			minWidth: 110,
			renderCell: (params) => {
				return (
					<Typography
						fontWeight={500}
						sx={{
							color: 'green',
							fontSize: {
								xl: '13px',
								lg: '10px',
								md: '10px',
								xs: '10px',
								sm: '10px',
							},
						}}
					>
						{params?.row?.Inactive === false || params?.row?.Inactive === null
							? 'Active'
							: ''}
					</Typography>
				);
			},
		},
		{
			field: 'discharge_date',
			headerName: 'Discharge Date',
			// width: 120,
			flex: 0.5,
			minWidth: 150,
			renderCell: (params) => {
				return (
					params?.row?.discharge_date !== null && (
						<span>
							{dayjs(params?.row?.discharge_date).format('MM/DD/YYYY')}
						</span>
					)
				);
			},
		},
	];
	return (
		<div>
			<Box
				sx={{
					width: '100%',
					height: {
						xl: '65vh',
						md: '50vh',
						lg: '50vh',
						sm: '55vh',
						xs: '55vh',
					},
					overflow: 'auto',
				}}
			>
				{' '}
				<DataGrid
					rows={activePatients}
					columns={columns}
					rowHeight={35}
					columnHeaderHeight={35}
					initialState={{
						pagination: { paginationModel: { pageSize: 10 } },
					}}
					pageSizeOptions={[10, 25, 50, 100]}
					sx={{
						'& .MuiDataGrid-columnHeaders': {
							backgroundColor: '#2081B8',
							color: '#FFFFFF',
						},
						fontSize: {
							xl: '13px',
							lg: '10px',
							md: '10px',
							xs: '10px',
							sm: '10px',
						},
					}}
					fontFamily={'Poppins'}
					getRowId={(row) => row.patient_id}
				/>
			</Box>
		</div>
	);
}
